import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Tag, Pencil, Eye } from "lucide-react";
import api, { formatErr } from "../../lib/api";

const STATUS_STYLES = {
  pending: { bg: "bg-copper/10", text: "text-copper", label: "Pending" },
  active: { bg: "bg-[#32D74B]/10", text: "text-[#32D74B]", label: "Live" },
  rejected: { bg: "bg-red-500/10", text: "text-red-400", label: "Rejected" },
};

export default function ShopMyProducts() {
  const [items, setItems] = useState([]);

  const refresh = async () => {
    try { const r = await api.get("/shop/my-products"); setItems(r.data); }
    catch (e) { toast.error(formatErr(e)); }
  };
  useEffect(() => { refresh(); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="overline mb-2">My Submissions</div>
        <h1 className="font-display text-4xl text-white">Product Submissions</h1>
        <p className="text-sm text-white/55 mt-2">Products you've submitted for admin approval, plus those that have gone live.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p) => {
          const st = STATUS_STYLES[p.status || "active"] || STATUS_STYLES.active;
          return (
            <div key={p.id} className="card-luxe overflow-hidden" data-testid={`mine-${p.id}`}>
              <div className="aspect-square bg-[#070707] relative">
                {p.images?.[0] && <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover"/>}
                <span className={`absolute top-2 left-2 text-[9px] uppercase tracking-luxe px-2 py-0.5 ${st.bg} ${st.text}`}>{st.label}</span>
              </div>
              <div className="p-4">
                <div className="font-display text-lg text-white truncate">{p.name}</div>
                <div className="text-xs text-copper uppercase tracking-luxe mt-1">{p.brand}</div>
                <div className="text-white text-sm mt-2">AED {p.price?.toLocaleString()}</div>
                {p.rejection_reason && (
                  <div className="text-xs text-red-300 mt-2 p-2 bg-red-500/5 border border-red-500/20">
                    <div className="overline mb-0.5 text-red-400">Reason</div>{p.rejection_reason}
                  </div>
                )}
                {p.sections?.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-2">
                    {p.sections.map((s) => <span key={s} className="text-[9px] uppercase tracking-luxe bg-white/5 text-white/70 px-2 py-0.5 flex items-center gap-1"><Tag size={9}/>{s.replace("_", " ")}</span>)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div className="card-luxe p-12 text-center text-white/40 col-span-full">You haven't submitted any products yet.</div>}
      </div>
    </div>
  );
}
